import * as React from "react";
const SvgDropdownCaretArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 7, height: 7, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "var(--color-theme-primary)", d: "m6.83 4.39-.57.56-2.43-2.43L1.4 4.95.83 4.4l3-3z" }));
export default SvgDropdownCaretArrow;
